import api from "./api";
import getApiHeader from "./getApiHeader";

export const mergeShoppingCart = async (skuId, userAccount, sessionId) => {
  const headers = await getApiHeader();
  let result;
  await api.shoppingCart
    .merge(
      null,
      {
        promotions: [
          //   {
          //     promotionId: 0,
          //     promotionType: "string"
          //   }
        ],
        skuId: skuId,
        skuCount: 1,
        sessionId
      },
      {
        headers
      }
    )
    .then(res => {
      result = res;
    });

  return result;
};

export const removeFromShoppingCart = async (
  skuId,
  skuCount,
  userAccount,
  sessionId
) => {
  const headers = await getApiHeader();
  let result;
  await api.shoppingCart
    .remove(
      null,
      {
        skus: [
          {
            skuCount,
            skuId
          }
        ],
        sessionId
      },
      {
        headers
      }
    )
    .then(res => {
      result = res;
    });

  return result;
};
export const getShoppingCart = async sessionId => {
  const headers = await getApiHeader();
  let result;
  await api.shoppingCart
    .merge(
      null,
      {
        sessionId
      },
      {
        headers
      }
    )
    .then(res => {
      result = res;
    });

  return result;
};

export const clearCart = async (skuIds, userAccount, sessionId) => {
  const headers = await getApiHeader();
  let result;
  await api.shoppingCart
    .remove(
      null,
      {
        skus: skuIds,
        sessionId
      },
      {
        headers
      }
    )
    .then(res => {
      result = res;
    });

  return result;
};
